module.exports = __webpack_public_path__ + "static/media/corderochuleta.c8a723ad.jpg";